import { colors } from '@creditornot/cb-ingredients';
import { pxToRem } from '@creditornot/cb-utils';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

import { Typography as T } from 'common/typography';

import { useInsightSubRoutes } from '../../../insights-v2/hooks/useInsightsSubRoutes';

const Root = styled.div`
  display: flex;
  background-color: ${colors.wolt8};
  padding: ${pxToRem(8)} ${pxToRem(16)};
  gap: ${pxToRem(4)};
`;

const CtaButton = styled(T.Body3)`
  color: ${colors.wolt100};
`;

type AdFreeTrialCallToActionHeroProps = {
  formattedTotalBudgetWithCurrency: string;
};

export const AdFreeTrialCallToActionHero = ({ formattedTotalBudgetWithCurrency }: AdFreeTrialCallToActionHeroProps) => {
  const { createAdCampaign } = useInsightSubRoutes();

  return (
    <Root data-test-id="ad-free-trial-cta-hero">
      <T.Body3>
        <FormattedMessage
          id="campaigns.ads.free-trials.insights-banner-text"
          values={{
            amount: formattedTotalBudgetWithCurrency,
          }}
        />
      </T.Body3>
      <Link to={createAdCampaign}>
        <CtaButton fontWeight="bold">
          <FormattedMessage id="campaigns.ads.free-trials.insights-banner-cta" />
        </CtaButton>
      </Link>
    </Root>
  );
};
